import "./HeroLogo.css";

export function HeroLogo() {
  return (
    <h1 className="hero-logo" id="home">
      <span className="hero-logo__word hero-logo__word--super crt-glow">SUPER</span>
      <span className="hero-logo__word hero-logo__word--smash crt-glow">SMASH</span>
      <span className="hero-logo__word hero-logo__word--tv crt-glow">TV</span>
    </h1>
  );
}
